module.exports = __webpack_public_path__ + "static/media/Eyebrows_ginger.7056e504.svg";